import { useEmployeeRecognitionRevoke } from "@/queries/employees/use-employee-recognitions.query.ts";
import { EmployeeRecognitionEditModal } from "@/pages/employees/employee/widgets/EmployeeRecognitionEditModal.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ApiEmployeeRecognition } from "@/types/recognitions/recognition.types.ts";
import {
  ConfirmationModal,
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuSeparator,
  FontAwesomeIcon,
  useModals,
} from "@skailer-com/uikit";
import React from "react";
import { useTranslation } from "react-i18next";

export interface RecognitionHistoryActionsMenuProps {
  recognition: ApiEmployeeRecognition;
}

export function RecognitionHistoryActionsMenu({ recognition }: RecognitionHistoryActionsMenuProps) {
  const { t } = useTranslation();
  const { renderEmployeeName } = useFormatter();
  const { openModal } = useModals();
  const revoke = useEmployeeRecognitionRevoke();

  const { employee, acl } = recognition;

  const openRevokeConfirmation = () => {
    openModal(ConfirmationModal, {
      question: t("recognition:revoke_question"),
      text: t("recognition:revoke_confirm", {
        title: recognition.recognition_title,
        name: renderEmployeeName(employee),
      }),
      acceptTitle: t("recognition:revoke"),
      onAccept: async () => {
        await revoke.mutateAsync({ employeeId: employee.id, itemId: recognition.id });
      },
    });
  };

  return (
    <DropdownMenu>
      {acl.can_edit && (
        <DropdownMenuItem
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            openModal(EmployeeRecognitionEditModal, { employee, recognition });
          }}
          title={t("common:edit")}
        />
      )}
      <DropdownMenuItem
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          window.open(`/employees/${employee.id}`, "_blank");
        }}
        title={
          <>
            {t("core:view_profile")}{" "}
            <FontAwesomeIcon
              icon={"fa-light fa-arrow-up-right-from-square"}
              className={"text-xs text-secondary"}
            />
          </>
        }
      />
      {acl.can_revoke && (
        <>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              openRevokeConfirmation();
            }}
            title={t("recognition:revoke")}
          />
        </>
      )}
    </DropdownMenu>
  );
}
